import styled from "styled-components";
import { UI_CAPTION_SEMIBOLD, colors2 } from "oolib";

export const FRESH_TOP_BAR_COLOR = "#8CDEA7";
export const STALE_TOP_BAR_COLOR = "#EAB5CA";

export const FRESH_COLOR = "#CBEDD6";
export const STALE_COLOR = "#F5DCE6";

export const StyledFreshness = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const StyledTopBarRow = styled.div`
  display: flex;
  width: 100%;
  gap: 0.3rem;
`;

export const StyledTopBar = styled.div<{ $variant: "fresh" | "stale"; $percent: number }>`
  flex: ${({ $percent }) => $percent};
  min-width: 0;
  height: 2.6rem;
  border-radius: 0.4rem;
  background: ${({ $variant }) => ($variant === "fresh" ? FRESH_TOP_BAR_COLOR : STALE_TOP_BAR_COLOR)};
  position: relative;
  overflow: hidden;
`;

export const StyledTopBarLabel = styled(UI_CAPTION_SEMIBOLD)<{ $variant: "fresh" | "stale" }>`
  position: absolute;
  top: 50%;
  ${({ $variant }) => ($variant === "fresh" ? "left: 8px" : "right: 8px")};
  transform: translateY(-50%);
  color: ${colors2.grey80};
  white-space: nowrap;
`;

export const StyledColumns = styled.div<{ $singleColumn?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $singleColumn }) => ($singleColumn ? "1fr" : "1fr 1fr")};
  gap: 1.2rem;
`;

export const StyledColumn = styled.div`
  min-width: 0;
`;
